module.exports = __webpack_public_path__ + "static/cube7-ac4d2d42ba821693077a8e6ac171d909.svg";